import React from 'react'
import { CenterContentStyled as Center } from '@core/Areas/Account/Pages/Activity/Components/Main/AccountActivityMain.styles'
import { DateHeader } from '@core/Areas/Account/Pages/Activity/Components/PagesDateHeader'
import { Ticket } from '@core/Areas/Account/Pages/Activity/Components/Ticket'
import {
  getIdFromSortedString,
  isFauxTicketTransaction,
} from '@core/Areas/Account/Pages/Activity/helpers'
import type { TicketResponseData } from '@core/Areas/Account/Pages/Activity/types'

// Main export to render collections of pages
export const Pages: React.FC<{
  pages: TicketResponseData[]
  isOrderByEvent: boolean
}> = ({ pages, isOrderByEvent }) => {
  const latestDateRef = React.useRef<string | null>(null)

  return pages.map((page, i) => {
    return (
      <Page
        key={page.pageNumber}
        page={page}
        isOrderByEvent={isOrderByEvent}
        latestDateRef={latestDateRef}
        isFirstPage={i === 0}
      />
    )
  })
}

// ===============
// local component
// ===============

// Single page to ensure best performance
const Page = React.memo<{
  page: TicketResponseData
  isOrderByEvent: boolean
  latestDateRef: React.MutableRefObject<string | null>
  isFirstPage: boolean
}>(({ page, isOrderByEvent, latestDateRef, isFirstPage }) => {
  return page.sortedIds.map((ticketId, i) => {
    const item = page.ticketsById[getIdFromSortedString(ticketId)]
    if (isFauxTicketTransaction(item))
      return (
        <Center key={ticketId}>
          <strong data-testid='transactions-faux-item'>{item.message}</strong>
        </Center>
      )

    return [
      <DateHeader
        key={'date.' + ticketId}
        isOrderByEvent={isOrderByEvent}
        eventStartDateTime={item.eventStartDateTime}
        timestamp={item.timestamp}
        latestDateRef={latestDateRef}
        isFirstDate={isFirstPage && i === 0}
      />,
      <Ticket key={ticketId} ticket={item} />,
    ]
  })
})

Page.displayName = 'Page'
